import React from 'react';
import {useState, useEffect} from 'react';
import {Link} from 'gatsby';
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Container,
} from "reactstrap";
import { StaticImage } from 'gatsby-plugin-image';

const savingsIcon: string = require("../../../../assets/images/company/carousel/pricing.png").default;
const notariesIcon: string = require("../../../../assets/images/company/carousel/notaries.png").default;
const servicesIcon: string = require("../../../../assets/images/company/carousel/services.png").default;
const dealershipIcon: string = require("../../../../assets/images/company/carousel/dealership.png").default;
const statesIcon: string = require("../../../../assets/images/company/carousel/states.png").default;
const activePricingIcon: string = require("../../../../assets/images/company/carousel/activePricing.png").default;
const activeServicesIcon: string = require("../../../../assets/images/company/carousel/activeServices.png").default;
const activeDealershipIcon: string = require("../../../../assets/images/company/carousel/activeDealership.png").default;
const activeNotariesIcon: string = require("../../../../assets/images/company/carousel/activeNotaries.png").default;
const activeStatesIcon: string = require("../../../../assets/images/company/carousel/activeStates.png").default;
const arrowUpIcon: string = require("../../../../assets/images/arrow-up.png").default;

import { TAB_PRICING, TAB_DEALERSHIP, TAB_NOTARIES, TAB_SERVICES, TAB_STATES } from '../../../../constants/company';

let tabs = [TAB_PRICING, TAB_SERVICES, TAB_DEALERSHIP, TAB_NOTARIES, TAB_STATES];

function CarouselSection() {

  const [activeTab, setactiveTab] = useState(TAB_PRICING);

  const toggle = (tab: string) => {
    let index = tabs.indexOf(tab);
    const firstPart = tabs.slice(0, index);
    const lastPart = tabs.slice(index);
    tabs = lastPart.concat(firstPart);
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

   useEffect(() => {
     const interval = setInterval(() => {
       const first = tabs.shift();
       if(first) {
        tabs.push(first);
       }
       setactiveTab(tabs[0]);
     }, 10000);
     return () => clearInterval(interval);
   }, []);

  return (
  <section className="section py-5 company-carousel-section">
    <Container>
      <Card className='mb-0'>
        <CardBody>
          <Nav pills className="navtab-bg nav-justified">
            <NavItem>
              <NavLink
              style={{ cursor: "pointer" }}
              onClick={() => {
                toggle(TAB_PRICING);
              }}
              >
                <div className='d-flex custom-tab-wrapper'>
                  {activeTab === TAB_PRICING ? <img src={activePricingIcon} alt="active pricing icon" /> : <img src={savingsIcon} alt="pricing icon" />}
                  <div className='d-flex flex-column align-items-start carousel-tabs'>
                    <div className='nav-link-title'>$75m+</div>
                    <div className='d-flex'>
                      <p className='nav-link-description'>Savings on fraud</p>
                      <img src={arrowUpIcon} alt="arrow up" className='mb-1 ms-2'/>
                    </div>
                  </div>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
              style={{ cursor: "pointer" }}
              onClick={() => {
                toggle(TAB_SERVICES);
              }}
              >
                <div className='d-flex custom-tab-wrapper'>
                  {activeTab === TAB_SERVICES ? <img src={activeServicesIcon} alt="active services icon" /> : <img src={servicesIcon} alt="services icon" />}
                  <div className='d-flex flex-column align-items-start carousel-tabs'>
                    <div className='nav-link-title'>400k+</div>
                    <div className='d-flex'>
                      <p className='nav-link-description'>Contract signings</p>
                      <img src={arrowUpIcon} alt="arrow up" className='mb-1 ms-2'/>
                    </div>
                  </div>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
              style={{ cursor: "pointer" }}
              onClick={() => {
                toggle(TAB_DEALERSHIP);
              }}
              >
                <div className='d-flex custom-tab-wrapper'>
                  {activeTab === TAB_DEALERSHIP ? <img src={activeDealershipIcon} alt="active dealership icon" /> : <img src={dealershipIcon} alt="dealership icon" />}
                  <div className='d-flex flex-column align-items-start carousel-tabs'>
                    <div className='nav-link-title'>3,000+</div>
                    <div className='d-flex'>
                      <p className='nav-link-description'>Dealership</p>
                      <img src={arrowUpIcon} alt="arrow up" className='mb-1 ms-2'/>
                    </div>
                  </div>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
              style={{ cursor: "pointer" }}
              onClick={() => {
                toggle(TAB_NOTARIES);
              }}
              >
                <div className='d-flex custom-tab-wrapper'>
                  {activeTab === TAB_NOTARIES ? <img src={activeNotariesIcon} alt="active notaries icon" /> : <img src={notariesIcon} alt="notaries icon" />}
                  <div className='d-flex flex-column align-items-start carousel-tabs'>
                    <div className='font-weight-700 font-size-24'>10,000+</div>
                    <div className='d-flex'>
                      <div className='font-weight-400 mb-0'>Certified notaries</div>
                      <img src={arrowUpIcon} alt="arrow up" className='mb-1 ms-2'/>
                    </div>
                  </div>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
              style={{ cursor: "pointer" }}
              onClick={() => {
                toggle(TAB_STATES);
              }}
              >
                <div className='d-flex custom-tab-wrapper'>
                  {activeTab === TAB_STATES ? <img src={activeStatesIcon} alt="active states icon" /> : <img src={statesIcon} alt="states icon" />}
                  <div className='d-flex flex-column align-items-start carousel-tabs'>
                    <div className='font-weight-700 font-size-24'>50</div>
                    <div className='d-flex'>
                      <div className='font-weight-400 mb-0'>States</div>
                      <img src={arrowUpIcon} alt="arrow up" className='mb-1 ms-2'/>
                    </div>
                  </div>
                </div>
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="p-3 text-muted mt-4 carousel-content">
            <TabPane tabId={TAB_PRICING}>
              <Row>
                <Col sm="12">
                  <div className="mb-0 d-flex carousel-info-wrapper">
                    <StaticImage src="../../../../assets/images/company/carousel/pricingPic.png" alt="A car dealer holding his savings from dodged fraudulent attempts in a jar" className='mx-5 my-4 carousel-img' placeholder="dominantColor"/>
                    <div className='carousel-info'>
                      <h1 className='carousel-title'>$75M+</h1>
                      <h1 className='carousel-title'>Savings on Fraud</h1>
                      <div className='carousel-subtitle'>Prevent fraudulent attempts on contract signing with Mavsign.</div>
                      <ul className='carousel-description'>
                        <li>Dealership Red Flag compliance implementation</li>
                        <li>Mavsign due diligence on potential Fraud attempts</li>
                      </ul>
                      <div className='button-wrapper'>
                        <Link to="/pricing" className='carousel-button p-2 font-weight-500 ms-2'>Start saving today!</Link>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={TAB_SERVICES}>
              <Row>
                <Col sm="12">
                  <div className="mb-0 d-flex carousel-info-wrapper">
                    <StaticImage src="../../../../assets/images/company/carousel/servicesPic.png" alt="Dealer and customer shaking hands after contract signing" className='mx-5 my-4 carousel-img' placeholder="dominantColor"/>
                    <div className='carousel-info'>
                      <h1 className='carousel-title'>400k+</h1>
                      <h1 className='carousel-title'>Contract Signings</h1>
                      <div className='carousel-subtitle'>Empower your dealership with secure contract signings.</div>
                      <ul className='carousel-description'>
                        <li>Accurate risk-free signing processes and Client Validation</li>
                        <li>Fast document turnaround time for completed signings</li>
                      </ul>
                      <div className='button-wrapper'>
                        <Link to="/services" className='carousel-button p-2 font-weight-500 ms-2'>Streamline your processes!</Link>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={TAB_DEALERSHIP}>
              <Row>
                <Col sm="12">
                  <div className="mb-0 d-flex carousel-info-wrapper">
                    <StaticImage
                      src="../../../../assets/images/company/carousel/dealershipPic.png" 
                      alt="Dealer and customers closing a deal in a car dealership by shaking hands" 
                      className='mx-5 my-4 carousel-img' 
                      placeholder="dominantColor"
                    />
                    <div className='carousel-info'>
                      <h1 className='carousel-title'>3,000+</h1>
                      <h1 className='carousel-title'>Dealerships</h1>
                      <div className='carousel-subtitle'>The nation's largest dealership grow with our help.</div>
                      <ul className='carousel-description'>
                        <li>Safe sales outside the dealership with remote signings</li>
                        <li>Secure client validation for in-store and offsite customers</li>
                      </ul>
                      <div className='button-wrapper'>
                        <Link to="/dealers" className='carousel-button p-2 font-weight-500 ms-2'>Scale up your dealership!</Link>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={TAB_NOTARIES}>
              <Row>
                <Col sm="12">
                  <div className="mb-0 d-flex carousel-info-wrapper">
                    <StaticImage 
                      src="../../../../assets/images/company/carousel/notariesPic.png" 
                      alt="Traveling notary placing stamp on remote signing car contract" 
                      className='mx-5 my-4 carousel-img' 
                      placeholder="dominantColor"
                    />
                    <div className='carousel-info'>
                      <h1 className='carousel-title'>10,000+</h1>
                      <h1 className='carousel-title'>Certified Notaries</h1>
                      <div className='carousel-subtitle'>Certified mobile notaries of our growing US network.</div>
                      <ul className='carousel-description'>
                        <li>Dealers' liaisons to remote signings</li>
                        <li>Assurance that contract signing is expedited for offsite clients</li>
                      </ul>
                      <div className='button-wrapper'>
                        <Link to="/notaries" className='carousel-button p-2 font-weight-500 ms-2'>Join our network!</Link>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={TAB_STATES}>
              <Row>
                <Col sm="12">
                  <div className="mb-0 d-flex carousel-info-wrapper">
                    <StaticImage 
                      src="../../../../assets/images/company/carousel/statesPic.png" 
                      alt="US map in foreground with all states covered by Mavsign services, platform users’ hand in background using the digital contracting signing service" 
                      placeholder="dominantColor" 
                      className='mx-5 my-4 carousel-img'
                    />
                    <div className='carousel-info'>
                      <h1 className='carousel-title'>50 States</h1>
                      <div className='carousel-title'>Safe remote signings across the nation.</div>
                      <ul className='carousel-description'>
                        <li>Nationwide Identity Validation and remote signings</li>
                        <li>Increased sales and profitability by reaching a national market</li>
                      </ul>
                      <div className='button-wrapper'>
                        <Link to="/contact-us" className='carousel-button p-2 font-weight-500 ms-2'>Contact us!</Link>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </Container>
  </section>
  )
}

export default CarouselSection;
